import script from "./Notification.vue?vue&type=script&setup=true&lang=ts"
export * from "./Notification.vue?vue&type=script&setup=true&lang=ts"

import "./Notification.vue?vue&type=style&index=0&id=1cea974f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cea974f"]])

export default __exports__